<template>
  <!-- KSK064 — pick the icon shown on a kiosk category tab / item card. -->
  <div class="kiosk-icon-picker">
    <button
      type="button"
      class="kiosk-icon-picker__opt"
      :class="{ active: !modelValue }"
      title="None"
      @click="$emit('update:modelValue', null)"
    >
      <span class="kiosk-icon-picker__none">None</span>
    </button>
    <button
      v-for="opt in icons"
      :key="opt.key"
      type="button"
      class="kiosk-icon-picker__opt"
      :class="{ active: modelValue === opt.key }"
      :title="opt.label"
      @click="$emit('update:modelValue', opt.key)"
    >
      <svg v-if="opt.svg" viewBox="0 0 24 24" aria-hidden="true">
        <component :is="shape.tag" v-for="(shape, i) in chefHat" :key="i" v-bind="shape.attrs" />
      </svg>
      <span v-else class="material-icons-round">{{ opt.icon }}</span>
    </button>
  </div>
</template>

<script>
import { KIOSK_ICONS, CHEF_HAT_SVG_SHAPES } from "@/config/kioskIcons";

export default {
  name: "KioskIconPicker",
  props: {
    modelValue: {
      type: String,
      default: null,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      icons: KIOSK_ICONS,
      chefHat: CHEF_HAT_SVG_SHAPES,
    };
  },
};
</script>

<style scoped>
.kiosk-icon-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.kiosk-icon-picker__opt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 0 8px;
  border: 1px solid #d2d6da;
  border-radius: 8px;
  background: #ffffff;
  color: #344767;
  cursor: pointer;
}
.kiosk-icon-picker__opt.active {
  border-color: #1871bd;
  background: #e8f1fa;
  color: #1871bd;
}
.kiosk-icon-picker__opt svg {
  width: 22px;
  height: 22px;
  fill: currentColor;
}
.kiosk-icon-picker__opt .material-icons-round {
  font-size: 22px;
}
.kiosk-icon-picker__none {
  font-size: 13px;
}
</style>
